module.exports = __webpack_public_path__ + "img/Fhf6AGhMdzT7cYk93wDJ50oQ3Meh.b86299ba.svg";